export function SkeletonBlock({ className }: { className?: string }) {
  return (
    <div className={`animate-pulse bg-container-light dark:bg-container-dark rounded ${className ?? ''}`} />
  )
}

export function SkeletonTable({ rows = 5, cols = 5 }: { rows?: number; cols?: number }) {
  return (
    <table className="w-full">
      <tbody>
        {Array.from({ length: rows }).map((_, r) => (
          <tr key={r} className="border-b border-border-light dark:border-border-dark">
            {Array.from({ length: cols }).map((_, c) => (
              <td key={c} className="px-4 py-3">
                <SkeletonBlock className="h-4 w-full" />
              </td>
            ))}
          </tr>
        ))}
      </tbody>
    </table>
  )
}
